<template>
    <v-row style="margin:2px">
        <v-btn size="small" variant="outlined" @click="presunSpat()">Späť</v-btn>
    </v-row>
    <v-row style="margin:2px" v-if="myInfolist">
        <v-card flat width="100%">
            <v-card-text>
                <h2 align="center">Informačný list predmetu</h2>
            </v-card-text>
            <v-card-text>
                <table border="1" style="padding:0px;spacing:0px;border-collapse: collapse;width:100%">
                    <tr><td colspan="2" style="padding:5px"><b>Vysoká škola:</b> Univerzita Konštantína Filozofa v Nitre</td></tr>
                    <tr><td colspan="2" style="padding:5px"><b>Fakulta:</b> Fakulta prírodných vied a informatiky</td></tr>
                    <tr>
                        <td style="padding:5px"><b>Kód predmetu:</b> {{myInfolist.skratka}}</td><td style="padding:5px"><b>Názov predmetu:</b> {{myInfolist.nazov}}</td>
                    </tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Druh, rozsah a metóda vzdelávacích činností:</b> <br>
                        <b>Forma výučby:</b> {{getForma()}}<br>
                        <b>Odporúčaný rozsah výučby (týždenný):</b> {{getRozsah()}}<br>
                        <b>Metóda štúdia:</b> prezenčná
                    </td></tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Typ predmetu: </b> {{myInfolist.typ}} <span v-if="myInfolist.priznak=='P'"> - profilový</span><br>
                        <b>Forma ukončenia: </b> {{myInfolist.ukoncenie}} <br>
                        <b>Počet kreditov: </b> {{myInfolist.kredity}}
                    </td></tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Odporúčaný ročník/semester štúdia:</b> {{myInfolist.rocnik}}/{{myInfolist.semester}}
                    </td></tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Stupeň štúdia:</b> {{myInfolist.stupen}}
                    </td></tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Podmienky na absolvovanie predmetu:</b> 
                        <div v-html="myInfolist.podm_absolvovania"></div>
                    </td></tr>
                    <tr><td colspan="2" style="padding:5px">
                        <b>Výsledky vzdelávania:</b> 
                        <div v-html="myInfolist.vysl_vzdelavania"></div>
                    </td></tr>                    
                    <tr><td colspan="2" style="padding:5px">
                        <b>Stručná osnova predmetu:</b> 
                        <div v-html="myInfolist.osnova"></div>
                    </td></tr>                    
                    <tr><td colspan="2" style="padding:5px">
                        <b>Odporúčaná literatúra:</b> 
                        <div v-html="myInfolist.literatura"></div>
                    </td></tr>   
                    <tr v-if="hodnotenia.length>0">
                        <td style="padding:5px">
                            <b>Hodnotenie predmetu:</b> <br>
                            Celkový počet hodnotených študentov: {{pocet_studentov}}    
                            <v-card flat>
                                <v-card-text>
                                    <v-row v-for="element, index in hodnotenia"  :key="index" style="margin:2px">
                                        <v-progress-linear :model-value="element.perc" height="15" color="#66bb6a">{{element.hod}}: {{element.pocet}} ({{element.perc}}%) </v-progress-linear>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </td>
                    </tr>
                </table>                
            </v-card-text>
        </v-card>
    </v-row>
</template>

<script>
import axios from '../../axios-auth.js'


export default {
    data() {
        return {
            myInfolist: null,
            pocet_studentov: 0,
            hodnotenia: [],
            values : [10,50,20,10,0]
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.prepareData()
        },
        prepareData() {
            const _data = {
                skratka: this.$route.params.id
            }
            axios.post('/get-infolist', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myInfolist = res.data.infolist[0]
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.pripravHodnotenie(this.myInfolist.hodnotenia)                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        presunSpat() {
            // console.log(this.$router.options.history.state.back)
            this.$router.go(-1)
        },
        getForma() {
            var _res = ''
            if (this.myInfolist.prednasky > 0) {
                _res = 'prednáška'
                if (this.myInfolist.seminare > 0) {
                    _res = _res + ' + cvičenie'
                }
            } else {
                _res = 'cvičenie / seminár'
            }
            return _res
        },
        getRozsah() {
            var _res = ''
            if (this.myInfolist.prednasky > 0) {
                _res = '' + this.myInfolist.prednasky + 'P'
                if (this.myInfolist.seminare > 0) {
                    _res = _res + ' + ' + this.myInfolist.seminare + 'C'
                }
            } else {
                _res = '' + this.myInfolist.seminare + 'C'
            }
            return _res
        },
        pripravHodnotenie(_data) {
            this.hodnotenia = []
            this.pocet_studentov = 0
            let i1 = 0
            if (_data.indexOf(';') == -1) return
            while (_data.indexOf(';') > -1) {
               i1 = _data.indexOf(':')
               let h = _data.substring(0,i1) 
               _data = _data.substring(i1+1)
               i1 = _data.indexOf(';')
               let num = parseInt(_data.substring(0,i1))
               this.pocet_studentov += num
               this.hodnotenia.push( {hod: h, pocet: num, perc: 0})
               _data = _data.substring(i1+1)
            }
            // console.log(this.hodnotenia)
            for(let i=0; i<this.hodnotenia.length; i++) {
                this.hodnotenia[i].perc = Math.round((this.hodnotenia[i].pocet / this.pocet_studentov) * 100)
            }
        }


    }
}
</script>